module.exports = __webpack_public_path__ + "img/15.50a5c62b.jpg";